import { render, staticRenderFns } from "./MaterialStatmentPage.vue?vue&type=template&id=3cf3b092&scoped=true&"
import script from "./MaterialStatmentPage.vue?vue&type=script&lang=js&"
export * from "./MaterialStatmentPage.vue?vue&type=script&lang=js&"
import style0 from "./MaterialStatmentPage.vue?vue&type=style&index=0&id=3cf3b092&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf3b092",
  null
  
)

export default component.exports